<template>
  <div class="raibudrrmain">
    <RtLayout
      class="raibudrrmain_item z-index_4"
      :class="[{ 'rtcs_no-transition': isFinished }, { rtcs_5x: mobile && isFinished }]"
      :flipped="!heroLeft"
      :showLeft="true"
      :showCenter="isFinished"
      :showRight="isFinished"
      :showBottom="!isFinished"
    >
      <template #left>
        <RtTableTitle
          v-show="isFinished"
          class="z-index_3"
          :flipped="heroLeft"
        >
          <template #left>
            <div
              class="weight_700 clr-grey text-nowrap f-align-center line-height_1 text-normal"
              style="gap: 0.25rem"
            >
              {{ $t('range_builder.chart_yours') }}
            </div>
          </template>
          <template #right>
            <!-- {{ isFinished }} -->
            <!-- <RangeCopyBtn
              :hasActions="true"
              :range="hero.range"
              :flipped="heroLeft"
              :solution="solution"
              :showBetsIn="showBetsIn"
              :useHex="useHex"
            /> -->
          </template>
        </RtTableTitle>
        <MessageOverlaySkeleton
          v-if="loadingStrategy"
          class="gw_mesblock_container"
          :isBlurred="true"
          :isTopDown="true"
          style="
            --content-margin: auto auto auto auto;
            --radius: 6px;
            left: -0.25rem;
            top: -0.35rem;
            height: calc(100% + 0.45rem);
            width: calc(100% + 0.25rem);
            --back-from: transparent;
            --back-to: transparent;
          "
        >
          <LoaderSpinner
            :style="`--size:4rem`"
            style="min-height: 3.5rem"
            data-tst="study_loaderspinner"
          />
        </MessageOverlaySkeleton>
        <div
          class="f-column flex-1 position-relative d-flex z-index_2 transition_03"
          :class="{ opacity_6: loadingStrategy }"
        >
          <ReactComponent
            v-if="$store.getters.user_has_flag('NODELOCK_V2')"
            name="RangeTable"
            :props="{
              tableGroups: rab_tableGroups,
              player: 'hero',
              showProp: 'strategy',
              viewProps: viewProps,
              playerGroupId: heroGroupId,
              playerGroupIds: heroGroupsIds,
              showBetsIn: showBetsIn,
              isCentered: isFinished,
              onClick: props => handleComboClick({ ...props, react: true }),
              onMouseEnter: handleComboMouseenterReact,
              onMouseDown: handleComboMousedown,
            }"
            @touchstart="e => $emit('table:mousedown', e)"
            @mousedown="e => $emit('table:mousedown', e)"
            @touchmove="e => $emit('table:touchmove', e)"
          />
          <StudyRangeTable
            v-else
            ref="table1"
            tour="rangetable"
            player="0"
            :namespace="namespace"
            :tableGroups="rab_tableGroups"
            :playerGroupId="heroGroupId"
            :playerGroupsIds="heroGroupsIds"
            :heroGroupId="heroGroupId"
            :setHoveredComboForHeroOnly="true"
            :viewProps="viewProps"
            :grouping="grouping"
            :useHex="useHex"
            :showBetsIn="showBetsIn"
            :tableMouseover="tableMouseover"
            :rangeKey="viewProps.rangeKey"
            showProp="strategy"
            :asEmpty="false"
            :noValue="true"
            :valueProp="viewProps.hero_valuePropTable"
            :isCentered="isFinished"
            asideTabKey="sw_rangebuilder_handmatrix"
            @touchstart="e => $emit('table:mousedown', e)"
            @mousedown="e => $emit('table:mousedown', e)"
            @touchmove="e => $emit('table:touchmove', e)"
            @combo:mousedown="handleComboMousedown"
            @combo:mouseenter="handleComboMouseenter"
            @combo:click="handleComboClick"
            @table:mouseleave="handleTableMouseleave"
          >
          </StudyRangeTable>

          <div
            class="d-flex w-100"
            style="margin: 0.25rem 0 0 0"
          >
            <HorizontalChart
              v-if="!isFinished"
              style="
                --chart-height: 1.25rem;
                --chart-radius: 4px;
                width: auto;
                flex: 1;
                --legend-margin: 0 0 0.125rem 0;
              "
              :solution="rab_solution_picked"
              class="horchart_legend-inline"
              :freKey="'strategy'"
              :grouping="grouping"
              :useHex="useHex"
              :skeleton="false"
              :hasLegend="false"
            />
            <!-- :hasLegend="true" -->
          </div>
        </div>
      </template>
      <template #center>
        <div
          class="raibudrrmain_center scroll-bottom-overlay f-column"
          style="
            --clr-scrl-back: var(--clr-back);
            --scrl-height: 1.25rem;
            --scrlb-inset: auto auto 2.5rem 0;
            min-height: 0;
            height: 100%;
          "
        >
          <RangeBuilderCenter
            v-if="isFinished"
            :mobile="mobile"
            :namespace="namespace"
            :rab_result="rab_result"
            :showBetsIn="showBetsIn"
            :showFlopContent="showFlopContent"
          >
            <template #after>
              <div
                class="d-flex mt-auto"
                style="gap: 0.25rem"
              >
                <div
                  class="gw_btn-v1 gw_btn gw_btn_primary flex-1"
                  @click="$emit('click:repeat')"
                >
                  {{ $t('btn.try_again') }}
                </div>
                <div
                  v-if="randomBoard"
                  class="gw_btn-v1 gw_btn gw_btn_primary flex-1"
                  @click="$emit('click:new_board')"
                >
                  {{ $t('btn.next_board') }}
                </div>
              </div>
            </template>
          </RangeBuilderCenter>
        </div>
      </template>
      <template #right>
        <RtTableTitle
          :flipped="!heroLeft"
          class="z-index_3"
        >
          <template #left>
            <div class="weight_700 clr-grey line-height_1 f-align-center text-normal">
              {{ $t('range_builder.chart_correct') }}
            </div>
          </template>
          <template #right>
            <!-- <RangeCopyBtn
              :flipped="!heroLeft"
              :range="hero.range"
              :hasActions="false"
              :showBetsIn="showBetsIn"
            /> -->
          </template>
        </RtTableTitle>

        <div class="f-column flex-1 position-relative d-flex z-index_2">
          <StudyRangeTable
            ref="table2"
            player="0"
            :namespace="namespace"
            :tableGroups="tableGroups"
            :playerGroupId="heroGroupId"
            :playerGroupsIds="heroGroupsIds"
            :heroGroupId="heroGroupId"
            :setHoveredComboForHeroOnly="true"
            :viewProps="viewProps"
            :grouping="grouping"
            :useHex="useHex"
            :showBetsIn="showBetsIn"
            :tableMouseover="tableMouseover"
            :rangeKey="viewProps.rangeKey"
            showProp="strategy"
            :asEmpty="false"
            :noValue="true"
            :valueProp="viewProps.hero_valuePropTable"
            :isCentered="isFinished"
            asideTabKey="sw_rangebuilder_handmatrix"
            @combo:mousedown="handleComboMousedown"
            @combo:mouseenter="handleComboMouseenter"
            @combo:click="handleComboClick"
            @table:mouseleave="handleTableMouseleave"
          >
          </StudyRangeTable>
        </div>
      </template>
    </RtLayout>
    <GwMenu
      v-if="isFinished"
      ref="gwmenu1"
      :referenceEl="referenceEl1"
      :boundary="boundary1"
      :isMovable="true"
    >
      <StudyCombos
        data-gwmenu="noclose"
        class="gw_floating-hands large-scroll-track"
        :style="boundary1 ? `max-width: ${boundary1.offsetWidth}px` : ''"
        player="0"
        :group="tableGroup1 || heroGroup"
        :viewProps="viewProps"
        :mobile="mobile"
        :grouping="grouping"
        :showBetsIn="showBetsIn"
        :rangeKey="viewProps.rangeKey"
        :combosMaximizible="false"
        showProp="strategy"
        :asEmpty="false"
        :hasBlockers="false"
        :useHex="useHex"
      />
    </GwMenu>
    <GwMenu
      v-if="isFinished"
      ref="gwmenu2"
      :referenceEl="referenceEl2"
      :boundary="boundary2"
      :isMovable="true"
      @close="resetPlayersGroups"
    >
      <StudyCombos
        data-gwmenu="noclose"
        class="gw_floating-hands large-scroll-track"
        :style="boundary2 ? `max-width: ${boundary2.offsetWidth}px` : ''"
        player="0"
        :group="tableGroup2 || heroGroup"
        :viewProps="viewProps"
        :mobile="mobile"
        :grouping="grouping"
        :showBetsIn="showBetsIn"
        :rangeKey="viewProps.rangeKey"
        :combosMaximizible="false"
        showProp="strategy"
        :asEmpty="false"
        :hasBlockers="false"
        :useHex="useHex"
      />
    </GwMenu>
  </div>
</template>

<script>
import GwMenu from '@/components/lib/GwMenu'
import HorizontalChart from '@/components/Charts/HorizontalChart/HorizontalChart'
import MessageOverlaySkeleton from '@/components/Poker/Overlays/MessageOverlaySkeleton'
import LoaderSpinner from '@/components/Loaders/LoaderSpinner'
import { SNK } from '@/helpers/helpers'
import { rangeTableGroups } from '@/helpers/solution'
import StudyRangeTable from '@/components/Study/StudyRangeTable'
// import RangeCopyBtn from '@/components/RangeCopyBtn/RangeCopyBtn'
import RtLayout from '@/components/RangeTables/RtLayout'
import RtTableTitle from '@/components/RangeTables/RtTableTitle'
import StudyCombos from '@/components/Study/StudyCombos'
import float_mix from '@/mixins/float_mix'
import RangeBuilderCenter from '@/components/Practice/RangeBuilder/RangeBuilderCenter'
import ReactComponent from '@/components/React/ReactComponent'

export default {
  name: 'RangeBuilderMain',
  components: {
    GwMenu,
    // StudyGraphSolutions,
    HorizontalChart,
    MessageOverlaySkeleton,
    LoaderSpinner,

    RangeBuilderCenter,
    RtTableTitle,
    StudyRangeTable,
    // RangeCopyBtn,
    RtLayout,
    StudyCombos,
    ReactComponent,
  },
  mixins: [float_mix],
  props: {
    namespace: { required: true, type: String },

    hSpot: Object,
    solution: { default: () => [] },
    solution_picked: { default: () => [] },
    tableGroups: { default: () => [] },

    rab_solution_picked: { default: () => [] },
    rab_tableGroups: { default: () => [] },
    rab_result: { default: () => ({}) },
    randomBoard: Boolean,

    isFinished: Boolean,
    showBetsIn: String,
    heroGroupId: String,
    heroGroupsIds: Array,
    heroLeft: Boolean,
    showFlopContent: Boolean,
    mobile: Boolean,
    heroGroup: Object,
    viewProps: Object,
    grouping: String,
    useHex: Boolean,
    tableMouseover: Boolean,
    skeletonOnly: Boolean,
    hasShortcutBtn: Boolean,
    loadingStrategy: Boolean,
  },
  emits: [
    'table:mousedown',
    'table:touchmove',
    'click:repeat',
    'click:new_board',
    'combo:mousedown',
    'combo:mouseenter',
    'combo:click',
  ],
  data() {
    return {
      canConfirm: false,

      tableGroup1: null,
      tableGroup2: null,
      referenceEl1: null,
      referenceEl2: null,
      boundary1: null,
      boundary2: null,

      lastTab: '',
    }
  },
  methods: {
    handleComboMousedown({ e, combos, disabled, trigger }) {
      if (this.isFinished) return
      this.$emit('combo:mousedown', { e, combos, disabled, trigger })
    },
    handleComboMouseenterReact({ e, combos, disabled, trigger }) {
      this.handleComboMouseenter({ e, combos, disabled, trigger })

      if (this.mobile) return
      if (this.heroGroupId) {
        return
      }

      if (disabled) {
        if (this.tableMouseover) {
          this.handleTableMouseleaveReact()
        }
        return
      }
      if (!this.tableMouseover) {
        this.handleTableMouseenterReact()
      }
      const player = 'hero'
      this.$store.commit(SNK('sol_detail_set', this.namespace), {
        key: 'study_player',
        value: player,
      })
      this.$store.commit(SNK('sol_detail_set', this.namespace), {
        key: `study_${player}_group`,
        value: combos,
      })
      this.$store.commit(SNK('sol_detail_set', this.namespace), {
        key: `study_${player}_hands_ids`,
        value: combos.combos.map(c => c.id),
      })
    },
    handleTableMouseenterReact() {
      if (this.mobile || this.heroGroupId || this.opponentGroupId) {
        return
      }
      this.$store.commit(SNK('sol_detail_set', this.namespace), {
        key: 'study_table_mouseover',
        value: true,
      })
      const asideTabKey = 'sw_rangebuilder_handmatrix'
      this.lastTab = this.$store.getters[asideTabKey]
      if (this.lastTab === 'filters') {
        this.$store.dispatch('switchers_set_item_by_value', {
          key: asideTabKey,
          value: 'hands',
        })
      }
    },
    handleTableMouseleaveReact() {
      this.handleTableMouseleave()

      if (this.mobile || this.heroGroupId || this.opponentGroupId) {
        return
      }
      this.$store.commit(SNK('sol_detail_set', this.namespace), {
        key: 'study_table_mouseover',
        value: false,
      })
      const asideTabKey = 'sw_rangebuilder_handmatrix'
      if (this.lastTab === 'filters') {
        if (this.heroGroupId || this.opponentGroupId) return
        this.$store.dispatch('switchers_set_item_by_value', {
          key: asideTabKey,
          value: 'filters',
        })
      }
    },
    handleComboMouseenter({ e, combos, disabled, trigger }) {
      if (this.isFinished) {
        if (disabled) {
          this.$store.commit(SNK('sol_detail_set', this.namespace), {
            key: 'players_detail',
            playerProperty: 'groups_ids',
            value: null,
            player: '0',
          })
          return
        }
        const groupsIds = rangeTableGroups().filter(ggId => ggId !== combos.id)
        this.$store.commit(SNK('sol_detail_set', this.namespace), {
          key: 'players_detail',
          playerProperty: 'groups_ids',
          value: groupsIds,
          player: '0',
        })
        return
      }
      this.$emit('combo:mouseenter', { e, combos, disabled, trigger })
    },
    handleTableMouseleave() {
      this.$store.commit(SNK('sol_detail_set', this.namespace), {
        key: 'players_detail',
        playerProperty: 'groups_ids',
        value: null,
        player: '0',
      })
    },
    handleComboClick({
      event,
      combos,
      showProp,
      player,
      playerGroupId,
      disabled,
      trigger,
      react = false,
    }) {
      if (react) {
        const group = playerGroupId === combos.id ? null : combos
        const mm = [
          {
            key: 'study_player',
            value: player,
          },
          {
            key: 'players_detail',
            playerProperty: 'group_id',
            value: '',
          },
          {
            key: 'players_detail',
            playerProperty: 'group_id',
            player,
            value: group?.id || '',
          },
          { key: 'players_detail', playerProperty: 'group', player, value: combos },
          {
            key: 'players_detail',
            playerProperty: 'hands_ids',
            player,
            value: combos.combos.map(c => c.id),
          },
        ]
        mm.forEach(m => {
          this.$store.commit(SNK('sol_detail_set', this.namespace), m)
        })
      }

      if (!this.isFinished) {
        this.$emit('combo:click', {
          event,
          combos,
          showProp,
          player,
          disabled,
          trigger,
        })
        return
      }
      const groupId = combos.id
      const open = this.tableGroup1?.id === groupId
      if (!open && this.$refs.table1 && this.$refs.table2) {
        this.tableGroup1 = this.rab_tableGroups.find(gg => gg.id === groupId)
        this.tableGroup2 = this.tableGroups.find(gg => gg.id === groupId)
        this.referenceEl1 = this.$refs.table1.$el.children[combos.table_index]
        this.referenceEl2 = this.$refs.table2.$el.children[combos.table_index]

        if (this.$refs.gwmenu1 && this.$refs.gwmenu2) {
          this.boundary1 = this.$refs.table1.$el
          this.boundary2 = this.$refs.table2.$el

          this.$refs.gwmenu1.toggleOpen(true)
          requestAnimationFrame(() => {
            this.$refs.gwmenu2.toggleOpen(true)
          })
        }
      } else {
        this.tableGroup1 = null
        this.tableGroup2 = null
        this.resetPlayersGroups()
      }
    },
    resetPlayersGroups(e) {
      this.$store.commit(SNK('sol_detail_set', this.namespace), {
        key: 'players_detail',
        playerProperty: 'group_id',
        value: '',
        player: '0',
      })
    },
  },
  computed: {
    tabCenterStrategy() {
      return this.$store.getters.sw_study_range_center === 'strategy'
    },
  },
}
</script>
<style lang="scss" scoped>
.raibudrrmain {
  --gap: var(--laytsttd-gap, 0.5rem);
  --padding-content: var(--laytsttd-padding-content, 0.5rem);
  --clr-back: var(--clr-black-1);

  flex-direction: column;
  display: flex;
  flex: 1;
  min-height: 0;
  min-width: 0;
  &_item {
    padding: var(--padding-content);
    background: var(--clr-back);
    border-radius: 6px;
    position: relative;
    &_bottom {
      margin-top: var(--gap);
      display: flex;
      flex: 1;
    }
  }
  &_ranges-comparison {
    padding: 0.5rem 0 0 0;
  }
}
</style>
